import React, { useState } from 'react';
import { submitOrderRequest } from '../../utils/api';

const TIRE_IMAGES = [
  'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=400&q=80',
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80',
  'https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=400&q=80',
  'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=400&q=80',
  'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=400&q=80',
  'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400&q=80',
];

const catalog = {
  16: [
    { size: '205/55R16', rating: '91H',  mspn: '35861', tags: [] },
    { size: '205/60R16', rating: '92V',  mspn: '61910', tags: [] },
    { size: '205/65R16', rating: '95H',  mspn: '76709', tags: [] },
    { size: '215/55R16', rating: '97H',  mspn: '03995', tags: ['XL'] },
    { size: '215/60R16', rating: '95V',  mspn: '31690', tags: [] },
  ],
  17: [
    { size: '205/50R17',  rating: '93V',   mspn: '93347', tags: ['XL'] },
    { size: '205/55R17',  rating: '95V',   mspn: '21343', tags: ['XL'] },
    { size: '215/45R17',  rating: '91V',   mspn: '17814', tags: ['XL'] },
    { size: '215/50R17',  rating: '95V',   mspn: '17193', tags: ['XL'] },
    { size: '215/55R17',  rating: '94V',   mspn: '46271', tags: [] },
    { size: '215/65R17',  rating: '99H',   mspn: '21093', tags: [] },
    { size: '225/45R17',  rating: '91V',   mspn: '54271', tags: [] },
    { size: '225/50R17',  rating: '98V',   mspn: '69757', tags: ['XL'] },
    { size: '205/40ZR17', rating: '(84Y)', mspn: '85024', tags: ['XL'] },
    { size: '205/45ZR17', rating: '(88Y)', mspn: '59525', tags: ['XL'] },
    { size: '215/55ZR17', rating: '(98Y)', mspn: '17729', tags: ['XL'] },
    { size: '225/50ZR17', rating: '(98Y)', mspn: '15411', tags: ['XL'] },
    { size: '225/55ZR17', rating: '(101Y)',mspn: '32676', tags: ['XL'] },
    { size: '245/45ZR17', rating: '(99Y)', mspn: '73361', tags: ['XL'] },
  ],
  18: [
    { size: '215/40ZR18', rating: '(89Y)', mspn: '47997', tags: ['XL'] },
    { size: '215/45ZR18', rating: '(93Y)', mspn: '74180', tags: ['XL'] },
    { size: '215/50R18',  rating: '92V',   mspn: '74612', tags: [] },
    { size: '215/55R18',  rating: '95H',   mspn: '44752', tags: [] },
    { size: '225/40R18',  rating: '92V',   mspn: '52883', tags: ['XL'] },
    { size: '225/45R18',  rating: '95W',   mspn: '87994', tags: ['XL','MB'] },
    { size: '225/45R18',  rating: '95Y',   mspn: '09346', tags: ['XL','BMW'] },
    { size: '225/45R18',  rating: '95V',   mspn: '49702', tags: ['XL'] },
    { size: '225/50R18',  rating: '95H',   mspn: '29568', tags: [] },
    { size: '225/55R18',  rating: '98H',   mspn: '04749', tags: [] },
    { size: '225/60R18',  rating: '104H',  mspn: '36488', tags: ['XL'] },
    { size: '235/40R18',  rating: '95V',   mspn: '45388', tags: ['XL'] },
    { size: '235/45R18',  rating: '98V',   mspn: '16172', tags: ['XL'] },
    { size: '235/50R18',  rating: '97V',   mspn: '28997', tags: [] },
    { size: '235/55R18',  rating: '104V',  mspn: '11315', tags: ['XL'] },
    { size: '235/60R18',  rating: '107V',  mspn: '29611', tags: ['XL'] },
    { size: '235/65R18',  rating: '106V',  mspn: '47167', tags: [] },
    { size: '245/40R18',  rating: '97V',   mspn: '34063', tags: ['XL'] },
    { size: '245/45R18',  rating: '100V',  mspn: '31804', tags: ['XL'] },
    { size: '245/55R18',  rating: '103V',  mspn: '09926', tags: [] },
    { size: '245/60R18',  rating: '109V',  mspn: '05213', tags: ['XL'] },
    { size: '255/35R18',  rating: '94V',   mspn: '04559', tags: ['XL'] },
    { size: '255/60R18',  rating: '112V',  mspn: '92640', tags: ['XL'] },
    { size: '255/65R18',  rating: '111H',  mspn: '90299', tags: [] },
    { size: '265/60R18',  rating: '110V',  mspn: '46728', tags: [] },
  ],
  19: [
    { size: '225/40R19',   rating: '93Y',   mspn: '58077', tags: ['XL','BMW'] },
    { size: '225/55R19',   rating: '103V',  mspn: '19326', tags: ['XL'] },
    { size: '235/35ZR19',  rating: '(91Y)', mspn: '81751', tags: ['XL'] },
    { size: '235/40R19',   rating: '96V',   mspn: '60820', tags: ['XL'] },
    { size: '235/45R19',   rating: '99V',   mspn: '16620', tags: ['XL'] },
    { size: '235/45ZR19',  rating: '(99Y)', mspn: '93065', tags: ['XL'] },
    { size: '235/50R19',   rating: '103V',  mspn: '44993', tags: ['XL'] },
    { size: '235/55R19',   rating: '105V',  mspn: '08499', tags: ['XL'] },
    { size: '235/60R19',   rating: '107V',  mspn: '26500', tags: ['XL'] },
    { size: '245/45R19',   rating: '102V',  mspn: '38373', tags: ['XL'] },
    { size: '245/45ZR19',  rating: '(102Y)',mspn: '01591', tags: ['XL'] },
    { size: '245/50R19',   rating: '105V',  mspn: '36113', tags: ['XL'] },
    { size: '245/55R19',   rating: '107V',  mspn: '18167', tags: ['XL'] },
    { size: '255/35R19',   rating: '96Y',   mspn: '96987', tags: ['XL','BMW'] },
    { size: '255/40R19',   rating: '100V',  mspn: '36073', tags: ['XL'] },
    { size: '255/45R19',   rating: '104V',  mspn: '23187', tags: ['XL'] },
    { size: '255/45ZR19',  rating: '(104Y)',mspn: '04606', tags: ['XL'] },
    { size: '255/55R19',   rating: '111V',  mspn: '67231', tags: ['XL'] },
    { size: '255/60R19',   rating: '109H',  mspn: '52171', tags: [] },
    { size: '265/50R19',   rating: '110V',  mspn: '70977', tags: ['XL'] },
    { size: '265/55R19',   rating: '113V',  mspn: '61256', tags: ['XL'] },
    { size: '275/40R19',   rating: '105V',  mspn: '38428', tags: ['XL'] },
    { size: '285/40ZR19',  rating: '(107Y)',mspn: '31259', tags: ['XL'] },
    { size: 'HL255/35R19', rating: '99Y',   mspn: '75810', tags: ['XL','BMW','HL'] },
  ],
  20: [
    { size: '235/45R20',   rating: '100H', mspn: '10503', tags: ['XL'] },
    { size: '235/45R20',   rating: '100W', mspn: '04688', tags: ['XL','MB'] },
    { size: '235/45R20',   rating: '100W', mspn: '55652', tags: ['XL','MB','Acoustic'] },
    { size: '235/50R20',   rating: '104V', mspn: '55754', tags: ['XL'] },
    { size: '235/55R20',   rating: '102V', mspn: '70750', tags: [] },
    { size: '245/40R20',   rating: '99W',  mspn: '52079', tags: ['XL'] },
    { size: '245/45R20',   rating: '103V', mspn: '11552', tags: ['XL'] },
    { size: '245/50R20',   rating: '105V', mspn: '91052', tags: ['XL'] },
    { size: '255/40R20',   rating: '101W', mspn: '61274', tags: ['XL'] },
    { size: '255/40R20',   rating: '101Y', mspn: '29670', tags: ['XL','AUD','Acoustic'] },
    { size: '255/40R20',   rating: '101Y', mspn: '07879', tags: ['XL','AUD','Acoustic'] },
    { size: '255/45R20',   rating: '105V', mspn: '30754', tags: ['XL'] },
    { size: '255/45R20',   rating: '105W', mspn: '65444', tags: ['XL','MAS'] },
    { size: '255/50R20',   rating: '109V', mspn: '92056', tags: ['XL'] },
    { size: '255/55R20',   rating: '110V', mspn: '57244', tags: ['XL'] },
    { size: '265/45R20',   rating: '108V', mspn: '08932', tags: ['XL'] },
    { size: '275/45ZR20',  rating: '(110Y)',mspn:'84948', tags: ['XL'] },
    { size: 'HL255/40R20', rating: '104W', mspn: '11774', tags: ['XL','MB','HL'] },
  ],
  21: [
    { size: '235/50R21',   rating: '101V', mspn: '70170', tags: [] },
    { size: '245/45R21',   rating: '104V', mspn: '31007', tags: ['XL'] },
    { size: '255/40R21',   rating: '102V', mspn: '03271', tags: ['XL'] },
    { size: '255/40R21',   rating: '102Y', mspn: '93724', tags: ['XL','AUD','Acoustic'] },
    { size: '265/40R21',   rating: '105V', mspn: '92075', tags: ['XL'] },
    { size: '265/45R21',   rating: '108V', mspn: '97084', tags: ['XL'] },
    { size: '275/40R21',   rating: '107V', mspn: '33925', tags: ['XL'] },
    { size: '275/45R21',   rating: '110V', mspn: '59733', tags: ['XL'] },
    { size: '285/45R21',   rating: '113V', mspn: '69136', tags: ['XL'] },
    { size: 'HL255/35R21', rating: '101Y', mspn: '66416', tags: ['XL','AUD','Acoustic','HL'] },
    { size: 'HL255/35R21', rating: '101Y', mspn: '87281', tags: ['XL','AUD','Acoustic','HL'] },
  ],
  22: [
    { size: '255/45R22',   rating: '107V', mspn: '00671', tags: ['XL'] },
    { size: '275/40R22',   rating: '107Y', mspn: '02126', tags: ['XL','BMW'] },
    { size: '275/40R22',   rating: '108V', mspn: '59847', tags: ['XL'] },
    { size: '285/40R22',   rating: '110W', mspn: '91725', tags: ['XL'] },
    { size: '285/45R22',   rating: '114H', mspn: '05254', tags: ['XL'] },
    { size: 'HL315/35R22', rating: '115Y', mspn: '01181', tags: ['XL','BMW','HL'] },
  ],
};

const TAG_COLORS = {
  XL:       { bg: '#e8f4fd', color: '#2d7dd2' },
  BMW:      { bg: '#1c1c1c', color: '#fff' },
  MB:       { bg: '#e8e8e8', color: '#222' },
  Acoustic: { bg: '#f0f7f0', color: '#27ae60' },
  AUD:      { bg: '#fff3e0', color: '#e65100' },
  MAS:      { bg: '#fce4ec', color: '#c62828' },
  HL:       { bg: '#ffd166', color: '#333' },
};

const OrderModal = ({ tire, onClose }) => {
  const [form, setForm] = useState({ name: '', phone: '', email: '', quantity: 1, message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitOrderRequest({
        customerName: form.name,
        phone: form.phone,
        email: form.email,
        address: 'To be confirmed',
        city: 'To be confirmed',
        subtotal: 0,
        message: `MSPN: ${tire.mspn} | Size: ${tire.size} | Rating: ${tire.rating} | Tags: ${tire.tags.join(', ')} | Customer note: ${form.message}`,
        items: [{
          name: `Michelin® ${tire.size} ${tire.rating}`,
          brand: 'Michelin',
          size: tire.size,
          quantity: Number(form.quantity),
          price: 0
        }]
      });
      setDone(true);
    } catch (err) {
      alert('Submission failed. Please try again or call us directly.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={modal.overlay} onClick={onClose}>
      <div style={modal.box} onClick={e => e.stopPropagation()}>
        {done ? (
          <div style={modal.success}>
            <p style={{ fontSize: '48px', margin: '0 0 12px' }}>✅</p>
            <h3 style={{ color: '#1a3a5c', margin: '0 0 8px' }}>Order Request Sent!</h3>
            <p style={{ color: '#4a5568', fontSize: '14px', margin: '0 0 20px' }}>
              Our team will contact you shortly to confirm your order.
            </p>
            <button style={modal.closeBtn} onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <div style={modal.header}>
              <div>
                <p style={{ color: '#c41e3a', fontSize: '11px', fontWeight: 'bold', letterSpacing: '2px', margin: '0 0 4px' }}>ORDER REQUEST</p>
                <h3 style={{ color: '#1a3a5c', margin: 0, fontSize: '18px' }}>Michelin® {tire.size}</h3>
                <p style={{ color: '#4a5568', fontSize: '13px', margin: '4px 0 0' }}>
                  {tire.rating} &nbsp;·&nbsp; MSPN #{tire.mspn}
                </p>
              </div>
              <button style={modal.xBtn} onClick={onClose}>✕</button>
            </div>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <input style={modal.input} placeholder="Your Full Name *" required
                value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
              <input style={modal.input} placeholder="Phone Number *" required
                value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
              <input style={modal.input} placeholder="Email (optional)"
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ color: '#4a5568', fontSize: '13px', whiteSpace: 'nowrap' }}>Quantity:</label>
                <input style={{ ...modal.input, width: '80px' }} type="number" min="1" max="20"
                  value={form.quantity} onChange={e => setForm({ ...form, quantity: e.target.value })} />
              </div>
              <textarea style={{ ...modal.input, height: '72px', resize: 'vertical' }}
                placeholder="Any special notes or questions..."
                value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} />
              <button type="submit" style={{ ...modal.submitBtn, opacity: submitting ? 0.7 : 1 }} disabled={submitting}>
                {submitting ? 'Sending...' : '📤 Send Order Request'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

const modal = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  box: { background: '#fff', borderRadius: '18px', padding: '28px', width: '100%', maxWidth: '440px', boxShadow: '0 24px 60px rgba(0,0,0,0.25)' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' },
  xBtn: { background: '#f5f7fa', border: 'none', borderRadius: '8px', width: '32px', height: '32px', cursor: 'pointer', fontSize: '16px', color: '#4a5568' },
  input: { width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: '9px', fontSize: '14px', color: '#1a3a5c', outline: 'none', background: '#f9fafc', boxSizing: 'border-box' },
  submitBtn: { padding: '13px', background: '#c41e3a', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer' },
  closeBtn: { padding: '10px 28px', background: '#1a3a5c', color: '#fff', border: 'none', borderRadius: '9px', cursor: 'pointer', fontWeight: '600' },
  success: { textAlign: 'center', padding: '20px 0' },
};

const RimCatalog = () => {
  const [selectedRim, setSelectedRim] = useState(17);
  const [orderTire, setOrderTire] = useState(null);
  const rimSizes = Object.keys(catalog).map(Number);
  const tires = catalog[selectedRim] || [];

  return (
    <div style={styles.section}>
      {orderTire && <OrderModal tire={orderTire} onClose={() => setOrderTire(null)} />}
      <div style={styles.container}>
        <p style={styles.tag}>MICHELIN® CATALOG</p>
        <h2 style={styles.title}>Browse by Rim Size</h2>
        <p style={styles.subtitle}>Select a rim size to explore Michelin® tires with MSPN codes</p>

        <div style={styles.rimRow}>
          {rimSizes.map(size => (
            <button key={size}
              style={{ ...styles.rimPill, ...(selectedRim === size ? styles.rimPillActive : {}) }}
              onClick={() => setSelectedRim(size)}
            >R{size}</button>
          ))}
        </div>

        <p style={styles.resultInfo}>
          Showing <strong>{tires.length} tire{tires.length !== 1 ? 's' : ''}</strong> for <strong>R{selectedRim}</strong>
        </p>

        <div style={styles.grid}>
          {tires.map((tire, i) => (
            <div key={`${tire.mspn}-${i}`} style={styles.card}>
              <div style={styles.imgBox}>
                <img src={TIRE_IMAGES[i % TIRE_IMAGES.length]} alt={tire.size} style={styles.img} />
                <span style={styles.mspnBadge}>#{tire.mspn}</span>
              </div>
              <div style={styles.cardBody}>
                <p style={styles.tireSize}>{tire.size}</p>
                <p style={styles.tireRating}>{tire.rating}</p>
                {tire.tags.length > 0 && (
                  <div style={styles.tagRow}>
                    {tire.tags.map(tag => (
                      <span key={tag} style={{ ...styles.tag2,
                        background: TAG_COLORS[tag]?.bg || '#f0f3f8',
                        color: TAG_COLORS[tag]?.color || '#4a5568'
                      }}>{tag}</span>
                    ))}
                  </div>
                )}
                <button style={styles.orderBtn} onClick={() => setOrderTire(tire)}>
                  Order Now →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  section: { background: '#f5f7fa', padding: '60px 20px' },
  container: { maxWidth: '1200px', margin: '0 auto', textAlign: 'center' },
  tag: { color: '#c41e3a', fontSize: '12px', fontWeight: 'bold', letterSpacing: '3px', marginBottom: '10px' },
  title: { color: '#1a3a5c', fontSize: '34px', fontWeight: 'bold', marginBottom: '10px' },
  subtitle: { color: '#4a5568', fontSize: '15px', marginBottom: '28px' },
  rimRow: { display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '20px' },
  rimPill: { padding: '10px 22px', background: '#fff', border: '2px solid #e2e8f0', borderRadius: '50px', cursor: 'pointer', fontSize: '15px', fontWeight: '700', color: '#1a3a5c', transition: 'all 0.2s' },
  rimPillActive: { background: '#1a3a5c', borderColor: '#1a3a5c', color: '#fff', boxShadow: '0 4px 14px rgba(26,58,92,0.25)' },
  resultInfo: { color: '#4a5568', fontSize: '13px', marginBottom: '24px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px', textAlign: 'left' },
  card: { background: '#fff', borderRadius: '14px', overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(26,58,92,0.05)', display: 'flex', flexDirection: 'column' },
  imgBox: { position: 'relative', height: '130px', overflow: 'hidden', background: '#eef2f7' },
  img: { width: '100%', height: '100%', objectFit: 'cover' },
  mspnBadge: { position: 'absolute', top: '8px', right: '8px', background: '#c41e3a', color: '#fff', fontSize: '10px', fontWeight: '700', padding: '3px 8px', borderRadius: '16px' },
  cardBody: { padding: '14px', display: 'flex', flexDirection: 'column', gap: '6px', flex: 1 },
  tireSize: { color: '#1a3a5c', fontSize: '15px', fontWeight: '800', margin: 0 },
  tireRating: { color: '#4a5568', fontSize: '12px', margin: 0 },
  tagRow: { display: 'flex', gap: '4px', flexWrap: 'wrap' },
  tag2: { fontSize: '9px', fontWeight: '700', padding: '2px 6px', borderRadius: '4px', textTransform: 'uppercase' },
  orderBtn: { marginTop: 'auto', padding: '9px', background: '#c41e3a', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' },
};

export default RimCatalog;
